import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useCurrentUser, useDefaultLandingPage, useIsSuperAdmin } from "../bridges/session";
import { LoadingSkeleton } from "../ui";

/**
 * /legacy/… and /next/… are for super admins only; everyone else goes to their default page.
 * `useIsSuperAdmin` answers false both for "not an admin" and "user not loaded yet", so we wait
 * for the user first — otherwise a real super admin reloading on /next/… would be sent home.
 */
export const SuperAdminOnly = ({ children }: { children: ReactNode }) => {
  const user = useCurrentUser();
  const isSuperAdmin = useIsSuperAdmin();
  const home = useDefaultLandingPage();
  if (!user) return <div className="cy-next"><LoadingSkeleton rows={6} /></div>;
  return isSuperAdmin ? <>{children}</> : <Navigate to={home} replace />;
};
